module.exports = __webpack_public_path__ + "assets/static/png/masterverified.2c025e82b9b1b44baea44d1c70f67e29.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/footer/images/masterverified.png
 ** module id = 478
 ** module chunks = 1
 **/